/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoGrantCreate } from '../../models/dto-grant-create';
import { GrantItem } from '../../models/grant-item';

export interface GrantControllerCreate$Params {
      body: DtoGrantCreate
}

export function grantControllerCreate(http: HttpClient, rootUrl: string, params: GrantControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: GrantItem;
}>> {
  const rb = new RequestBuilder(rootUrl, grantControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: GrantItem;
      }>;
    })
  );
}

grantControllerCreate.PATH = '/grant';
